import StepperMenu from './steps/StepperMenu';
import {useDispatch, useSelector} from "react-redux";
import {getStepWithStatus, getStepWithStatusCompany} from "../methods/GetStepWithStatus";
import {ChangeStep} from "../redux/actions/StepperAction";
import {setReuse, setStatus} from "../redux/actions/TokneAction";
import {getStatus} from "../../api/MoadianService";
import {useEffect} from "react";
import StepperMenuCompany from "./steps/StepperMenuCompany";

export default function Main() {

    const tokenInfo = useSelector( state => state.Token)
    const firstInfo = useSelector( state => state.FirstInfo)
    const dispatch = useDispatch()

    useEffect( () => {
        if (tokenInfo.reuse == 1) {
            getStatus(tokenInfo.transactionId).then(response => {

                dispatch(setStatus({status: response?.data?.transactionStatus}));
                if(firstInfo.certType == 'COMPANY') {
                    getStepWithStatusCompany(response?.data?.transactionStatus, dispatch, ChangeStep)
                }else{
                    getStepWithStatus(response?.data?.transactionStatus, dispatch, ChangeStep)
                }
                dispatch(setReuse({reuse: 2 }))

            }).catch( error => console.warn(error))
        }
    }, [])



    return(
        <div className="p-3 pt-4  p-md-5">
            {
                firstInfo.certType == 'COMPANY' ?
                    <StepperMenuCompany /> :
                    <StepperMenu />
            }
        </div>
    )
}